const onlineservices = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'Online Services',
            },
            {
                "type": "tabs",
                "size": "12",
                "style": "",
                "class": "px-4 pt-4",
                "children": [
                    {
                        "title": "Settings",
                        "service": "category",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "updateSuccessTitle": 'Category Updated!',
                            "updateSuccessMessage": 'Category Updated Successfully!',
                            "updateErrorTitle": 'Category Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                        },
                        "children": [
                            {
                                "type": "descriptionTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "type": "list",
                                    "size": "4",
                                    "style": "",
                                    "class": "p-2",
                                    "empty": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "form": {
                                        "text": {
                                        "type": 'ckeditor',
                                        "label": 'Page Description',
                                        "placeholder": 'Enter Description',
                                        "required": false,
                                        "info": true,
                                        "character_count": 1000,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            },                            
                        ]
                    },
                    {
                        "title": "Services",
                        "service": "pages",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": true,
                            "deleteButton": false, 
                            "addNewSuccessTitle": 'Topic Added!',
                            "addNewSuccessMessage": 'Topic Added Successfully!',
                            "addNewErrorTitle": 'Topic Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Topic Deleted!',
                            "deleteSuccessMessage": 'Topic Deleted Successfully!',
                            "deleteErrorTitle": 'Topic Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Topic Activated!',
                            "activeSuccessMessage": 'Topic Activated Successfully!',
                            "activeErrorTitle": 'Topic Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Topic Updated!',
                            "updateSuccessMessage": 'Topic Updated Successfully!',
                            "updateErrorTitle": 'Topic Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New Topic",
                                "submit_url": "/api/categories/$currentCategoryId/pages",
                                "variant": "add",
                                "form": {
                                    "title": {
                                        "type": 'text',
                                        "label": 'Topic Title',
                                        "placeholder": 'Enter Topic Title',
                                        "required": true,
                                        "info": true,
                                        "character_count": 250,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                    },
                                },
                            }
                        },
                        "children": [
                            {
                                "type": "jobVacanciesTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "label": "Select a Service",
                                    "type": "list",
                                    "info": true,
                                    "size": "4",
                                    "style": "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "p-0 pt-3 pr-3",
                                    "load_url": "/api/categories/$currentCategoryId/pages",
                                    "draggable": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "submit_url": "/api/pages/$currentPageId",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'Label',
                                            "placeholder": 'Enter Title',
                                            "required": true,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": true,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        }
                                    },
                                    "children": [
                                    ]
                                }
                            }
                        ]
                    }
                ]
            },

        ]
    }
]

export { onlineservices };